import React from "react";
import { AlertTriangle } from "lucide-react";

export default function AlWarningBanner({ alDiff }) {
  if (alDiff === null || alDiff < 0.2) return null;
  return (
    <div data-testid="al-warning-banner" className="reveal rounded-xl border border-amber-300 bg-amber-50 px-5 py-4 flex gap-3">
      <AlertTriangle className="w-5 h-5 mt-0.5 text-amber-600 shrink-0" />
      <div>
        <div className="font-semibold text-amber-900">Axial Length anisometropia detected</div>
        <div className="text-sm text-amber-800 mt-1">
          |OD.AL − OS.AL| = <span className="font-mono">{alDiff.toFixed(2)} mm</span> — exceeds the 0.2 mm clinical threshold
          {alDiff >= 0.3 && " (HIGH severity, > 0.3 mm)"}. Please verify optical/ultrasound biometry before proceeding to IOL power selection.
        </div>
      </div>
    </div>
  );
}
